<% var component = new Anvil.models.components.Password(field) %>
<% if ('inline' in field && field.inline) { %>
<div anvil-component="<%- component.id %>" class="col">
	<% if ('prepend' in field || 'append' in field) { %><div class="input-group"><% } %>
	<% if ('prepend' in field) { %><%- field.prepend %><% } %>
	<input type="password" class="form-control" id="<%= form.name %>_<%= field.name %>" name="<%= field.name %>" value="<%= form.data[field.name] %>" onchange="" <% if ('attributes' in field) for (let key in field.attributes) { %><%- key %>="<%- field.attributes[key] %>" <% } %> />
	<% if ('append' in field) { %><%- field.append %><% } %>
	<% if ('prepend' in field || 'append' in field) { %></div><% } %>
</div>
<% } else { %>
<div anvil-component="<%- component.id %>" class="form-group row">
	<div class="col-<%= ('label_width' in form.params) ? form.params.label_width : '4' %>">
		<label for="<%= form.name %>_<%= field.name %>" class="control-label"><%= field.title %></label>
	</div>
	<div class="col">
		<% if ('prepend' in field || 'append' in field) { %><div class="input-group"><% } %>
		<% if ('prepend' in field) { %><%- field.prepend %><% } %>
		<input type="password" class="form-control" id="<%= form.name %>_<%= field.name %>" name="<%= field.name %>" value="<%= form.data[field.name] %>" onchange="" <% if ('attributes' in field) for (let key in field.attributes) { %><%- key %>="<%- field.attributes[key] %>" <% } %> />
		<% if ('append' in field) { %><%- field.append %><% } %>
		<% if ('prepend' in field || 'append' in field) { %></div><% } %>
		<% if ('help' in field) { %><small class="form-text text-muted"><%- field.help %></small><% } %>
		<div class="invalid-feedback"></div>
	</div>
</div>
<% } %>
